import { sendRequest, ppAxios } from '../config'

/**
 * 商户后台分页查询公告
 */
export const queryAnnouncementPage = (params) => {
  return sendRequest(['POST', '/merchant/acquirer/announcement/queryAnnouncementPage'], params)
}

/**
 * 获取公告详情
 */
export const getAnnouncementDetail = (id) => {
  return sendRequest(['POST', '/merchant/acquirer/announcement/getAnnouncementDetail'], { announcementMerchantId: id })
}

/**
 * 获取未读消息数量
 */
export const getUnreadMessageCount = () => {
  return sendRequest(['POST', '/merchant/acquirer/announcement/getAnnouncementNoReadCount'])
}

/**
 * 附件下载
 */
export const fileDownload = (params) => {
  return ppAxios(["GET", "/merchant/acquirer/file/download"], params, {
    responseType: "blob"
  })
}
